import Facility from "./facility";

export default class PatientChartTransferFacility extends Facility {
  hospiceTransferDatetime: Date;
  previousHospiceAdmissionDatetime: Date;
  previousHospiceProviderNumber: string;

  constructor(
    hospiceTransferDatetime: Date,
    previousHospiceAdmissionDatetime: Date,
    previousHospiceProviderNumber: string
  ) {
    super();
    this.hospiceTransferDatetime = hospiceTransferDatetime;
    this.previousHospiceAdmissionDatetime = previousHospiceAdmissionDatetime;
    this.previousHospiceProviderNumber = previousHospiceProviderNumber;
  }
}



// WEBPACK FOOTER //
// ./src/models/facilities/patient-chart-transfer-facility.ts